import {SollapayLogoIllustration, SollapayLogomarkIllustration} from '@sollapay/ui/illustrations';

import type {FC} from 'react';

const brandA11yProps = {role: 'img', 'aria-label': 'Sollapay'} as const;

export const AppLogomark: FC = () => (
  <SollapayLogomarkIllustration
    {...brandA11yProps}
    className="h-8 w-auto shrink-0 text-brand-accent"
  />
);

export const AppLogo: FC = () => (
  <SollapayLogoIllustration {...brandA11yProps} className="h-6 w-auto text-brand-accent" />
);
